module.exports = __webpack_public_path__ + "assets/images/custom-cues@2x-51349ceef75e1bf52186038569451e67.png";